import { Background } from '../enums/BackgroundEnum';

export const config = {
    name: 'Features Cards',
    inputs: [
        {
            name: 'heading',
            type: 'string',
            required: true,
            defaultValue: 'The Storyblocks difference',
        },
        {
            name: 'bodyText',
            friendlyName: 'Body Text',
            type: 'richText',
            defaultValue:
                'Optional body copy here: Using stock footage saves video producers time and money, and our library offers a nearly endless supply of content.',
            onChange: (options) => {
                const characterLimit = 300;
                const bodyText = options.get('bodyText');
                const htmlTagRegex = /<.*?>/gi;

                const textOnly = bodyText.replaceAll(htmlTagRegex, '');
                if (textOnly.length <= characterLimit) {
                    return;
                }

                const tokenizedTags = [...bodyText.matchAll(htmlTagRegex)].map((item) => item[0]);
                const tokenizedText = bodyText.split(htmlTagRegex);

                const trimmedTextNodes = tokenizedText.reduce((textNodes, text) => {
                    const currentTextLength = textNodes.join('').length;
                    return currentTextLength + text.length <= characterLimit
                        ? textNodes.concat(text)
                        : textNodes.concat(text.slice(0, characterLimit - currentTextLength));
                }, []);

                const trimmedRichText = tokenizedTags.map((tag, i) => trimmedTextNodes[i] + tag).join('');

                alert(`Max of ${characterLimit} characters allowed.`);
                options.set('bodyText', trimmedRichText);
            },
        },
        {
            name: 'backgroundColor',
            friendlyName: 'Background Color',
            type: 'color',
            defaultValue: '',
            helperText: 'Select a custom background color for the section',
        },
        {
            name: 'cardBackgroundColor',
            friendlyName: 'Card Background Color',
            type: 'color',
            defaultValue: '',
            helperText: 'Select a custom background color for the cards',
        },
        {
            name: 'cardPadding',
            friendlyName: 'Card Padding',
            type: 'string',
            defaultValue: '',
            helperText: 'e.g., "16px", "2rem", "10px 20px".',
            regex: {
                pattern:
                    '^\\s*((0|\\d+(?:\\.\\d+)?)(px|em|rem|%|vw|vh|ch|ex|vmin|vmax|cm|mm|in|pt|pc|Q|lh|rlh|vi|vb|ic)\\s*){1,4}$',
                options: 'i',
                message: 'Invalid padding format. Please use 1 to 4 values with units (e.g., "24px", "16px 24px").',
            },
        },
        {
            name: 'enableMobileSwipe',
            friendlyName: 'Enable Mobile Swipe',
            type: 'boolean',
            defaultValue: false,
            helperText: 'Allow users to swipe horizontally through cards on mobile devices',
        },
        {
            name: 'featureCards',
            friendlyName: 'Feature Cards',
            type: 'list',
            required: true,
            helperText:
                'A list of feature cards highlighting key differentiators. Each card includes an image, title, and description.',
            defaultValue: [
                {
                    image: '',
                    imageAlt: 'High quality diverse stock library',
                    title: 'High-quality, diverse stock library',
                    body: 'Our library is expertly curated to provide the in-demand content you need to make your creative stand out.',
                },
                {
                    image: '',
                    imageAlt: 'Premium quality assets',
                    title: 'Premium Quality Assets',
                    body: 'Access professionally produced content that meets the highest standards of quality and creativity.',
                },
                {
                    image: '',
                    imageAlt: 'Unlimited downloads',
                    title: 'Unlimited Downloads',
                    body: 'Download as many assets as you need without worrying about additional costs or limitations.',
                },
                {
                    image: '',
                    imageAlt: 'Commercial license',
                    title: 'Commercial License',
                    body: 'Use our content for any commercial project with our comprehensive licensing agreement.',
                },
            ],
            onChange: (options) => {
                const maxAllowed = 8;

                if (options.get('featureCards').length > maxAllowed) {
                    options.set('featureCards', options.get('featureCards').slice(0, maxAllowed));
                    alert(
                        `Maximum number of feature cards allowed is ${maxAllowed}. Modify an existing feature card instead.`,
                    );
                }
            },
            subFields: [
                {
                    name: 'image',
                    friendlyName: 'Image',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
                    required: false,
                    helperText: 'Upload an image for the feature card',
                },
                {
                    name: 'imageAlt',
                    friendlyName: 'Image Alt Text',
                    type: 'string',
                    required: true,
                    helperText: 'Descriptive text for screen readers and accessibility',
                },
                {
                    name: 'title',
                    friendlyName: 'Card Title',
                    type: 'string',
                    required: true,
                },
                {
                    name: 'body',
                    friendlyName: 'Card Body',
                    type: 'richText',
                    required: true,
                    helperText: 'Description text for the feature card',
                },
            ],
        },
        {
            name: 'Identifier',
            type: 'string',
            enum: ['Shell'],
            defaultValue: 'Shell',
            advanced: true,
            onChange: (_, context) => {
                context.set('Identifier', 'Shell');
            },
            helperText: "Identifier for the repo, don't change this",
        },
    ],
};
